export enum PaymentProcessingStatus {
    None,
    Declined,
    Error,
    Success,
    DuplicateCard,
    PaymentLimit,
    NeedsAction,
}